import Button from "@/components/ui/button";
import StepLayout from "../step-layout";
import { useFeedbackFlow } from "../../hooks/use-feedback-flow";
import IconLightbulb from "@/components/icons/icon-lightbulb";

export default function StepTestimonialIntro() {
	const { nextStep } = useFeedbackFlow();

	return (
		<StepLayout
			header={<h1 className="text-2xl font-semibold text-primary">Share Your Story</h1>}
			content={
				<div className="space-y-4">
					<p className="text-secondary leading-relaxed">
						Your testimonial is the greatest gift you can give us. It helps us grow and allows others to discover what we do through your genuine experience.
					</p>
					<ul className="text-secondary space-y-4">
						<li className="flex items-start gap-2">
							<span className="text-brand mt-0.5">•</span>
							<span>We'll ask a few simple questions—respond via text or video, whichever suits you.</span>
						</li>
						<li className="flex items-start gap-2">
							<span className="text-brand mt-0.5">•</span>
							<span>This quick form lets you decide exactly what we can share and where.</span>
						</li>
						<li className="flex items-start gap-2">
							<span className="text-brand mt-0.5">•</span>
							<span>You have full control over where your testimonial is shared.</span>
						</li>
					</ul>
				</div>
			}
			footer={
				<div className="flex flex-col justify-center">
					<div className="flex items-center gap-2 text-tertiary pt-2 justify-center mb-4">
						<IconLightbulb className="w-5 h-5 text-amber-500 shrink-0" />
						<span>Takes less than 5 minutes. And hey, you look great today!</span>
					</div>
					<Button onClick={nextStep} variant="brand" className="w-full">
						Send a Testimonial
					</Button>
				</div>
			}
		/>
	);
}
